import { getRoutes } from '@ui-framework/index';
import ApiDocumentation from './pages';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

const Pages = ProtectedRoute => ({
  ApiDocumentation: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ApiDocumentation}
    />
  ),
});
const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = () => [];

export { ApiDocumentation, routes, stores };
